import { Component, OnInit } from '@angular/core';
import { PopoverRef } from '../popover/popover-ref';

export interface MegaMenuFeature {
  icon: string;
  label: string;
  route: string;
}

export interface MegaMenuPage {
  label: string;
  route: string;
}

@Component({
  selector: 'vex-mega-menu',
  templateUrl: './mega-menu.component.html'
})
export class MegaMenuComponent implements OnInit {

  features: MegaMenuFeature[] = [
    {
      icon: '',
      label: 'LR Tools',
      route: 'http://lrtools/home'
    },
    {
      icon: '',
      label: 'Sales Force',
      route: 'https://legal-resources.my.salesforce.com/console'
    },
    {
      icon: '',
      label: 'CICO',
      route: 'http://legaldc/cico'
    },
    {
      icon: '',
      label: 'IR',
      route: 'http://ir/'
    },
    {
      icon: '',
      label: 'SSRS',
      route: 'http://legalgp/reports/browse'
    },
    {
      icon: '',
      label: 'Stax Bill',
      route: 'https://admin.staxbill.com'
    },
    {
      icon: '',
      label: 'ADP',
      route: 'https://workforcenow.adp.com/'
    },
    {
      icon: '',
      label: 'Attorney Finder',
      route: 'https://attorneyportallr.azurewebsites.net/Attorney'
    },
    {
      icon:'',
      label: 'Help Desk',
      route: 'https://legalresources-e0eecd1f217c11.sharepoint.com/HelpDeskPlus/Pages/Default.aspx'
    }
  ];

  pages: MegaMenuPage[] = [
    {
      label: 'All-In-One Table',
      route: '/apps/aio-table'
    },
    {
      label: 'Authentication',
      route: '/login'
    },
    {
      label: 'Components',
      route: '/ui/components/overview'
    },
    {
      label: 'Documentation',
      route: '/documentation'
    },
    {
      label: 'FAQ',
      route: '/pages/faq'
    },
    {
      label: 'Form Elements',
      route: '/ui/forms/form-elements'
    },
    {
      label: 'Form Wizard',
      route: '/ui/forms/form-wizard'
    },
    {
      label: 'Guides',
      route: '/pages/guides'
    },
    {
      label: 'Help Center',
      route: '/apps/help-center'
    },
    {
      label: 'Scrumboard',
      route: '/apps/scrumboard'
    }
  ];

  constructor(private popoverRef: PopoverRef<MegaMenuComponent>) { }

  ngOnInit() {
  }

  close() {
    this.popoverRef.close();
  }
}
